import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  Stack,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import FieldItem from "./FieldItem";
import FieldEditorModal from "./FieldEditorModal";

const FormBuilder = () => {
  const [fields, setFields] = useState([]);
  const [openEditor, setOpenEditor] = useState(false);
  const [editingField, setEditingField] = useState(null);

  // Réordonner les champs
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const reordered = Array.from(fields);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);

    // Mise à jour de order
    const withOrder = reordered.map((f, index) => ({
      ...f,
      order: index + 1,
    }));

    setFields(withOrder);
  };

  return (
    <Box>
      {/* HEADER */}
      <Stack direction="row" justifyContent="space-between" mb={2}>
        <Typography variant="h6">Constructeur de formulaire</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            setEditingField(null);
            setOpenEditor(true);
          }}
        >
          Ajouter un champ
        </Button>
      </Stack>

      {/* DRAG & DROP LIST */}
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="fieldsList">
          {(provided) => (
            <Stack
              spacing={2}
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {fields.length === 0 && (
                <Card sx={{ p: 3, textAlign: "center", color: "#777" }}>
                  Aucun champ pour le moment
                </Card>
              )}

              {fields.map((field, index) => (
                <Draggable
                  key={field.id}
                  draggableId={field.id}
                  index={index}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                    >
                      <FieldItem
                        field={field}
                        dragHandleProps={provided.dragHandleProps}
                        onEdit={() => {
                          setEditingField(field);
                          setOpenEditor(true);
                        }}
                        onDelete={() =>
                          setFields(fields.filter((f) => f.id !== field.id))
                        }
                      />
                    </div>
                  )}
                </Draggable>
              ))}

              {provided.placeholder}
            </Stack>
          )}
        </Droppable>
      </DragDropContext>

      {/* MODAL D'ÉDITION */}
      <FieldEditorModal
        open={openEditor}
        onClose={() => setOpenEditor(false)}
        field={editingField}
        onSave={(f) => {
          if (editingField) {
            // update
            setFields(fields.map((fld) => (fld.id === f.id ? f : fld)));
          } else {
            // add
            setFields([...fields, { ...f, id: crypto.randomUUID() }]);
          }
          setOpenEditor(false);
        }}
      />
    </Box>
  );
};

export default FormBuilder;
